import React from 'react';

const LEGAL_BLURB =
  'Model Camp: tauche ein in die bezaubernde Welt von Model Camp. Mit Bestätigung der Schaltfläche Weiter stimmen Sie den allgemeinen Geschäftsbedingungen zu. Kosten: 1 x 10 CHF Sunrise / 2 x 5 CHF Swisscom / 3 x 5 CHF Salt pro Woche. Wenn Sie Hilfe benötigen, kontaktieren Sie uns bitte indem Sie eine E-Mail an customercare@getpay.ch senden oder telefonisch unter 41445816170. Zusätzliche GPRS-Gebühren können angewendet werden. Die Zusendung der MO SMS wird nach Ihrem Tarif model verrechnet. Um Ihr Abo zu kündigen, senden Sie dazu einfach eine SMS mit STOP MC an die 464.';

const links = [
  { label: 'AGB', href: '/agb.html' },
  { label: 'Impressum', href: '/impressum.html' },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#faf7f4] border-t border-stone-200 py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-xs text-stone-500 leading-relaxed mb-8 max-w-5xl mx-auto text-center sm:text-left">
          {LEGAL_BLURB}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          <a href="/" className="flex items-center select-none">
            <span className="text-xl font-black tracking-tight text-stone-900">Model</span>
            <span className="text-xl font-black tracking-tight text-rose-900">Camp</span>
          </a>

          <nav className="flex items-center gap-6 flex-wrap justify-center">
            {links.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-sm text-stone-500 hover:text-rose-900 transition-colors duration-200"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <p className="text-sm text-stone-400 whitespace-nowrap">© {year} ModelCamp</p>
        </div>
      </div>
    </footer>
  );
}
